import React from "react";
import Image from "next/legacy/image";
import styles from "./style.module.scss";
import { translate } from "@helpers/translationObjectFormatter";
import { useQuery } from "@tanstack/react-query";
import { TranslationsObject } from "@genericTypes/sharedTypes";
const Introduction = () => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <section className=" mt-32">
            <div className=" flex flex-col lg:flex-row lg:gap-[170px] gap-20 items-center lg:items-start">
                <div className=" sm:max-w-[480px] max-w-[314px] order-2 lg:order-1 mx-2 lg:mx-0">
                    <h1 className="font-extrabold  lg:text-4xl text-2xl leading-9">
                        {translate(
                            translations,
                            "several_aboutUsPage_AboutUsTitle",
                        )}
                    </h1>

                    <p className="font-medium  lg:mt-7 mt-3 leading-8">
                        <span className="font-bold">Several.com</span>{" "}
                        {translate(
                            translations,
                            "several_aboutUsPage_AboutUsDescription",
                        )}
                    </p>
                </div>
                <div className=" sm:h-[331px] h-[231px]  relative sm:w-[434px] w-[314px] lg:top-9 order-1 lg:order-2 ">
                    <Image
                        src="/aboutUs/aboutusimg1.png"
                        layout="fill"
                        alt="about us image"
                        width={434}
                        height={331}
                    />
                </div>
            </div>
            <div className=" rtl:lg:pb-20 flex lg:gap-[124px] gap-20 flex-col lg:flex-row lg:-mt-16 items-center lg:items-start mt-12">
                <div className=" sm:max-w-[526px] max-w-[314px]  order-2 lg:order-1 mx-2 lg:mx-0">
                    <h2 className="font-extrabold  lg:text-4xl text-2xl lg:leading-[54px] leading-10 ">
                        {translate(
                            translations,
                            "several_aboutUsPage_digitalWorldDescription",
                        )}
                    </h2>
                    <p
                        className={`${styles["paragraphColor"]} font-medium  mt-5   leading-8`}
                    >
                        {translate(
                            translations,
                            "several_aboutUsPage_digitalWorldTitle",
                        )}
                    </p>
                </div>
                <div className=" sm:h-[331px] h-[231px]  relative sm:w-[434px] w-[314px] lg:top-36 order-1 lg:order-2">
                    <Image
                        src="/aboutUs/aboutusimg2.png"
                        layout="fill"
                        alt="about us image"
                        width={434}
                        height={331}
                    />
                </div>
            </div>
        </section>
    );
};

export default Introduction;
